import { NotificationStatus } from '@gtpl/shared-models/common-models';
import { Column, Entity,Index, PrimaryGeneratedColumn, VersionColumn, CreateDateColumn, UpdateDateColumn } from 'typeorm';

@Entity('notifications')
export class Notifications{

    @PrimaryGeneratedColumn('increment', {name: 'notification_id'})
    notificationId: number;

    @Column("int", {
        nullable: false,
        name: "plant_id"
      })
      plantId: number;

    @Column('varchar', {
        nullable: true,
        length: 50,
        name: 'plant'
    })
    plant: string;

    @Column('varchar', {
        nullable: true,
        length: 60,
        name: 'job_role'
    })
    jobRole: string;
   

    @Column('varchar', {
        nullable: false,
        length: 60,
        name: 'job_description'
    })
    jobDescription: string;

    @Column({
        nullable: false,
        name: 'notificaiton_date'
    })
    notificationDate: Date;

    @Column('varchar', {
        nullable: false,
        length: 30,
        name: 'resource_required'
    })
    resourceRequired: string;

    @Column('varchar', {
        nullable: false,
        length: 30,
        name: 'skills'
    })
    skills: string;

    @Column('varchar', {
        nullable: false,
        length: 30,
        name: 'year_of_experience'
    })
    yearOfExperience: string;

    @Column({
        nullable: false,
        name: 'planned_closing_date'
    })
    plannedClosingDate: Date;

    @Column('varchar',{
        nullable: true,
        length: 60,
        name: 'remarks'
    })
    remarks: string;

    @Column({
        type: 'enum',
        enum: NotificationStatus,
        name: 'status',
        default: NotificationStatus.Open
    })
    status: NotificationStatus;

    @Column('boolean', {
        nullable: false,
        default: true,
        name: 'is_active'
    })
    isActive: boolean;

    @CreateDateColumn({
        name: 'created_at',
        type: 'datetime'
    })
    createdAt: Date;

    @Column('varchar', {
        nullable: false,
        name: 'created_user'
    })
    createdUser: string | null;
    
    @UpdateDateColumn({
        name: 'updated_at',
        type: 'datetime'
    })
    updatedAt: Date;

    @Column('varchar', {
        nullable: true,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

   
}